module.exports = __webpack_public_path__ + "media/application/images/ui/deal-how-to-instore-purchase-c53f1dd79c907cf0a24af2d5ee1dea93.png";